module.exports = __webpack_public_path__ + "img/SX.2a074db1.png";